import {
    Center,
    Image,
    Stack,
    Text,
  } from '@chakra-ui/react'
  
  export const CartProductMeta = (props) => {
    const { Name, photoURL } = props
    return (
      <Stack direction="row" spacing="5" width="full">
        <Image
          rounded="lg"
          width="120px"
          height="120px"
          fit="cover"
          src={photoURL}
          alt={Name}
          draggable="false"
          loading="lazy"
        />
        <Center>
          <Stack spacing="0.5">
            <Text fontWeight="medium">{Name}</Text>
          
          </Stack>
        </Center>
      </Stack>
    )
  }